import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  allFocusMemberData: any;
  error: string;
}

const initialArgs: Master = {
  allFocusMemberData: [],
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useFocusMember = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getAllMember = async (
    page: string,
    listPerPage: string,
    searchValue: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/users/getAllMember?page=${page}&pageSize=${listPerPage}&searchValue=${searchValue}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          allFocusMemberData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const updateFocusMember = async (week: string, users: any) => {
    const paramObj = {
      week,
      users,
    };
    try {
      const result: any = await api.patch(
        `/api/users/update-user-role`,
        paramObj,
      );

      if (result.data.status) {
        toast.success(result.data.message, {
          id: "updateUserToast",
        });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr, { id: "updateUserToastError" });
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message, { id: "updateUserToastError" });
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Developer Wise Site API End*/

  return {
    // New Code Start
    getAllMember,
    updateFocusMember,
    // New Code End
    ...state,
  };
};

export default useFocusMember;
